import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { IDropdown } from "../interfaces";

@Component({
  selector: "able-dropdown",
  templateUrl: "./able-dropdown.component.html",
})
export class AbleDropdownComponent implements OnInit {
  @Input() dropdownList: Array<IDropdown>;
  @Input() currentDropValue: string;
  @Input() noSelectedValueText: string = "";
  @Input() fullWidthButton: boolean = false;
  @Input() smallButton: boolean = false;
  @Input() isDisabled: boolean = false;
  @Output() OnChange = new EventEmitter();

  searchDropValue: string = "";
  showNoResultsMessage: boolean = false;
  dropSearch: boolean = false;

  ngOnInit(): void {
    if (!this.currentDropValue) {
      if (this.noSelectedValueText) {
        this.currentDropValue = this.noSelectedValueText;
      } else {
        this.noSelectedValueText = "Select a value";
        this.currentDropValue = "Select a value";
      }
    }
  }

  dropdownChanged(selectedDropValue: any): void {
    this.currentDropValue = selectedDropValue.label;
    this.OnChange.emit(selectedDropValue.value);
  }
}
